import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import useIsMobileView from "../../utils/hooks/useIsMobileView";

function desktopTitle(title: string) {
  return (
    <Typography align="left" variant="h5" sx={styles.desktopTitle}>
      <Link to="/" style={reactLinkStyle}>
        {title}
      </Link>
    </Typography>
  );
}

function mobileTitle(title: string) {
  return (
    <Typography align="center" variant="h6" sx={styles.mobileTitle}>
      {title}
    </Typography>
  );
}

const Title = (props: { text: string }) => {
  const IsMobileView = useIsMobileView();
  return <>{IsMobileView ? mobileTitle(props.text) : desktopTitle(props.text)}</>;
};

export default Title;

const styles = {
  desktopTitle: {
    letterSpacing: ".1rem",
    fontStyle: "normal",
    fontWeight: 700,
    color: "#000000",
    textDecoration: "none",
  },
  mobileTitle: {
    letterSpacing: ".1rem",
    fontStyle: "normal",
    fontWeight: 700,
    color: "#000000",
    textDecoration: "none",
  },
};
const reactLinkStyle = {
  color: "#000000",
  textDecoration: "none",
};
